import { HttpClient, HttpEvent, HttpHeaders, HttpParameterCodec, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Configuration } from "@app/common/configuration";
import { Observable} from "rxjs";
import { environment } from '../../../environments/environment';
import { TriggerReleaseDto } from "../model/triggerReleaseDto";
import { apiResponseFormat } from "@app/common/variables";

type httpHeaderAccept = "text/plain" | "application/json" | "text/json";
@Injectable({
    providedIn: 'root'
})
export class ReleaseCreationService{
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;
    authServerUrl = environment.API_APP_PATH;

    constructor(private readonly http: HttpClient,) {

    }
    

    /**
     * Creates a release pipeline.
     * @param releaseId The ID of the release.
     * @param selectedEnvironmentId The ID of the selected environment.
     * @param observe The type of observation to be performed.
     * @param reportProgress Whether to report progress.
     * @param options Additional options for the HTTP request.
     * @returns An observable that emits the result of the API call.
     */
       public apiPostCreateReleasePipeline(
  triggerReleaseDto: TriggerReleaseDto
   
    ): Observable<boolean>
    {
        let headers = this.defaultHeaders;
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/plain',
                'application/json',
                'text/json'
            ];
        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers.set('Accept', httpHeaderAcceptSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        responseType = httpHeaderAcceptSelected?.startsWith('text') ? 'text' : 'json';
        return this.http.post<boolean>(
            `${this.authServerUrl}/api/app/trigger-release/trigger`,
            triggerReleaseDto,
            {
                responseType: responseType as any, // or cast to <any> if needed
                withCredentials: this.configuration.withCredentials,
                headers: headers,
            }
        );
    }

}